import * as yup from 'yup';

export const buildConfigValidator = (schema) => (config) => yup.object().shape(schema).required().isValidSync(config);

export const validate = (schema, value) => schema.isValidSync(value);
